import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import styles from "./deviceSection.css"

const DeviceSectionText = ({ customStyle, text, title }) => (
  <div className={classnames(styles.panel, styles.panelText, customStyle)}>
    <h2 className={styles.title}>{title}</h2>
    {text}
  </div>
)

DeviceSectionText.propTypes = {
  customStyle: PropTypes.string,
  text: PropTypes.node.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
}

export default DeviceSectionText
